// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 600 ? "piano" : chunkId) + "." + {"600":"e9478e91","753":"e12cdc94"}[chunkId] + ".js";
};